export default __webpack_public_path__ + "static/media/evaluation-procedure.bdf65396.svg";